export default __webpack_public_path__ + "39cb247d5f10ded537c0efd6ba923c2e.svg";